import React from 'react';
import styled, { withTheme } from 'styled-components';
import { TopNavBar, Screen, BottomTabBar, FavListY } from '../components';
import coins from '../data/favCapCoins.json';

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  padding: 2px 0;
  background: ${props => props.theme.fav.bg};
`;

const FavoritesY = ({ theme }) => (
  <Screen theme={theme} title="Favorites">
    <TopNavBar title="Coinmend" left="ios-grid-outline" right="ios-add" rightSize="32px" />
    <Content>
      <FavListY coins={coins} />
    </Content>
    <BottomTabBar selected="favorites" />
  </Screen>
);

export default withTheme(FavoritesY);



// WEBPACK FOOTER //
// ./src/screens/FavoritesY.js